import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "share",
  "use": "share-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"share\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 3.5c0 .187.02.369.06.544L5.597 7.14a2.5 2.5 0 10-.066 2.816l4.524 3.016a2.5 2.5 0 10.412-.928L5.943 9.028a2.51 2.51 0 00.019-.96l.017.024 4.498-3.121A2.5 2.5 0 1010 3.5zm-5 5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm7.5 6.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM14 3.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol